<template>
	<div class="main" v-title data-title="零部件基本资料">
		<iHeader></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1"><span @click="collect">我的收藏</span> - [{{collectname}}] 收藏夹列表</h1>
					</div>
				</div>
				<div class="demo-image">
					<div class="block blockInfocate" v-for="(item,index) in collectionListdata" @mousemove="addClassload($event)"
					 @mouseout="removeClassload($event)" @click="jumpurl(item.product_id)">
						<!-- <div class="demonstration font14 fl mt25 color3 h10">{{ item.title }}</div> -->
						<el-image style="width: 190px; height: 190px" :src="'https://images.mfcad.cn/'+item.thumb"
						 fit="cover" @mousemove="ImgaddClassload($event)" @mouseout="ImgremoveClassload($event)"></el-image>

						<div class="demonstration font14 fl mt25 pdb10 color3 h10" style="line-height: 15px;">{{ item.title }}</div>
						<!-- <div class="font14 fl mt10 bold overtitle" style="width: 100%;">{{item.catid_name}}</div> -->
					</div>
				</div>
				<div class="txc mt25" v-if="nodata ==true">
					<p>暂无数据</p>
				</div>

				<div class="block pdb10 " style="float: right">
					<el-pagination @current-change="handleCurrentChange"  @size-change="handSizeChange" :current-page.sync="page" :page-sizes="[12, 24, 36]"
					 :page-size="100" layout="prev, pager, next,sizes,total" :total='total'>
					</el-pagination>
				</div>


			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import VDistpicker from 'v-distpicker'
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	import Cookies from 'js-cookie'
	export default {
		components: {
			iHeader,
			vFooter,
			VDistpicker,
			vnav,
		},
		data() {
			return {
				titleDec: "",
				favorite_id: this.$route.query.favorite_id,
				collectionListdata: [],
				page: 1,
				pcount: 12,
				total: 1,
				nodata: false,
				collectname: '',
				// 个人资料
				ruleForm: {
					name: '',
					sex: '2',
					Cname: '',
					type: ['1'],
					uni: [],
					// 行业
				},
				editForm: {
					name: '',
					sex: '',
					Cname: '',
					type: '',
					uni: '',
					hy: ''
				},
				flagForm: true,
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}, ],
					sex: [{
						required: true,
						message: '请选择性别',
						trigger: 'change'
					}],
					type: [{
						type: 'array',
						required: true,
						message: '请至少选择一个活动性质',
						trigger: 'change'
					}],
				},
				loadingplant: false,
				crop: {},
				plant: {},
				plants: [],
				crops: [],
				pid: 0,
				// 省市区
				scity: {},
				suni: {},
				sarea: {},
				scitys: [],
				sunis: [],
				sareas: [],
				uniflag: true,
				typestr: []
			};
		},
		created() {
			// 获取收藏列表
			this.collectionList();
		},
		methods: {
			handflag() {
				this.flagForm = false;
			},
			addClassload($event) {
				$event.currentTarget.className = "block blockInfocate active";
			},
			removeClassload($event) {
				$event.currentTarget.className = "block blockInfocate";
			},
			ImgaddClassload($event) {
				$event.currentTarget.className = "el-image__inner Wactive";
			},
			ImgremoveClassload($event) {
				$event.currentTarget.className = "el-image__inner";
			},
			jumpurl(id) {
				let routeData = this.$router.resolve({
					name: "content",
					query: {
						goodsid: id
					}
				})
				window.open(routeData.href, '_blank');
			},
			handleCurrentChange(val) {
				this.page = val;
				this.collectionList();
			},
			handSizeChange(val){
				this.pcount=val;
				this.collectionList();
			},
			collect() {
				let routeData = this.$router.resolve({
					path: "collection"
				})
				window.open(routeData.href, '_self');
			},
			collectionList() {
				this.$postcn('partshome/collectionList', {
					'favorite_id': this.favorite_id,
					'page': this.page,
					'pagesize': this.pcount
				}, this).then((res) => {
					// 加载数据
					// console.log(res);
					this.collectname = res.data.name;
					if (res.data.code == 200) {
						this.collectionListdata = res.data.data;
						this.total = res.data.count;
						if (this.collectionListdata.length == 0) {
							this.nodata = true
						} else {
							this.nodata = false
						}
					} else {
						this.collectionListdata = []
						this.nodata = true
					}

				})
			},
		}
	}
</script>

<style lang="stylus" scoped>
	.item1 {
		display: inline-block;
	}

	.el-breadcrumb {
		height: 62px;
		line-height 62px !important;
		font-size: 14px;
	}

	.el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
		color: #9298a2
	}

	.el-submenu {
		width: 100%
	}

	.el-menu--popup-bottom-start {
		margin-top: 0px !important;
	}

	.el-menu--popup-right-start {
		margin: 0px !important;
	}

	.blockInfocate {
		padding: 10px 10px 20px 10px;
		text-align: center;
		display: inline-block;
		width: 245px;
		margin: 10px;
		box-sizing: border-box;
		vertical-align: top;
		background-color: #fafafa;
		border: 1px solid #eaeaea;
	}

	.h10 {
		height: 30px;
	}

	.demonstration {
		letter-spacing: 0;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		line-height: 20px;
		width: 100%;
	}

	.el-submenu__icon-arrow {
		right: 10px;
	}

	.Cinput {
		display: inline-block !important;
		width: 300px !important;
	}

	.item1 {
		display: inline-block;
	}

	.Tnum {
		display: inline-block;
		float: right;
		margin-right: 30px;
		line-height: 40px;
	}

	.active {
		border-color: #1f75cf;
		color: #1f75cf;
	}

	.el-submenu .el-menu-item,
	.el-submenu__title {
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
		// width: 220px;
	}

	.overtitle {
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
		width: 240px;
	}

	.Wactive {
		width: 190PX;
		cursor: pointer;
		transform: scale(1.5, 1.5)
	}

	.el-pagination .el-select .el-input .el-input__inner {
		padding-right: 25px;
		border-radius: 3px;
		height: 25px !important;
		line-height: 25px !important;
		width: 100px !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/people/collectiondetail.vue